var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import images from "../../assets";
import * as S from "./FullScreenState2.styles";
import { EStateType } from "./FullScreenState2.types";
var FullScreenState = /** @class */ (function (_super) {
    __extends(FullScreenState, _super);
    function FullScreenState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullScreenState.prototype.render = function () {
        var _a = this.props, title = _a.title, info = _a.info, stateType = _a.stateType, primaryActionTitle = _a.primaryActionTitle, secondaryActionTitle = _a.secondaryActionTitle, extraActionTitle = _a.extraActionTitle, onPressPrimaryAction = _a.onPressPrimaryAction, onPressSecondaryAction = _a.onPressSecondaryAction, onPressExtraAction = _a.onPressExtraAction;
        return (_jsxs(S.Wrap, __assign({ stateType: stateType }, { children: [_jsx(S.InnerWrap, { children: _jsxs(S.Circle1, __assign({ stateType: stateType }, { children: [_jsx(S.Circle2, __assign({ stateType: stateType }, { children: _jsx(S.Circle3, { stateType: stateType }, void 0) }), void 0), _jsxs(S.IconWrap, { children: [stateType === EStateType.Success && (_jsx(S.Icon, { source: images.ICO_CHECK_WHITE }, void 0)), stateType === EStateType.Error && (_jsx(S.Icon, { source: images.ICO_CLOSE_WHITE }, void 0)), stateType === EStateType.Loading && (_jsx(S.Icon, { source: images.ICO_LOADING_WHITE }, void 0))] }, void 0)] }), void 0) }, void 0), _jsxs(S.BottomWrap, { children: [_jsx(S.Title, { children: title }, void 0), info && _jsx(S.Info, { children: info }, void 0), _jsxs(S.ButtonWrap, { children: [secondaryActionTitle && (_jsx(S.ButtonSecondaryStyled, { onPress: onPressSecondaryAction, title: secondaryActionTitle, isInverted: true }, void 0)), primaryActionTitle && (_jsx(S.ButtonPrimaryStyled, { onPress: onPressPrimaryAction, title: primaryActionTitle }, void 0))] }, void 0), extraActionTitle && (_jsx(S.ExtraButton, { onPress: onPressExtraAction, title: extraActionTitle }, void 0))] }, void 0)] }), void 0));
    };
    return FullScreenState;
}(React.PureComponent));
var FullScreenLoadingState = /** @class */ (function (_super) {
    __extends(FullScreenLoadingState, _super);
    function FullScreenLoadingState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () { return (_jsx(FullScreenState, __assign({}, _this.props, { stateType: EStateType.Loading }), void 0)); };
        return _this;
    }
    return FullScreenLoadingState;
}(React.PureComponent));
export { FullScreenLoadingState };
var FullScreenErrorState = /** @class */ (function (_super) {
    __extends(FullScreenErrorState, _super);
    function FullScreenErrorState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () { return (_jsx(FullScreenState, __assign({}, _this.props, { stateType: EStateType.Error }), void 0)); };
        return _this;
    }
    return FullScreenErrorState;
}(React.PureComponent));
export { FullScreenErrorState };
var FullScreenSuccessState = /** @class */ (function (_super) {
    __extends(FullScreenSuccessState, _super);
    function FullScreenSuccessState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () { return (_jsx(FullScreenState, __assign({}, _this.props, { stateType: EStateType.Success }), void 0)); };
        return _this;
    }
    return FullScreenSuccessState;
}(React.PureComponent));
export { FullScreenSuccessState };
export default FullScreenState;
